import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { load, save } from 'redux-localstorage-simple'

import apollo from './apollo/apolloReducer'
import application from './application/reducer'
import burn from './burn/reducer'
import burnV3 from './burn/v3/reducer'
import collections from './collections/reducer'
import createOrder from './createOrder/reducer'
import { api as dataApi } from './data/slice'
import { updateVersion } from './global/actions'
import lists from './lists/reducer'
import logs from './logs/slice'
import mints from './mints/reducer'
import multicall from './multicall/reducer'
import orders from './orders/reducer'
import { routingApi } from './routing/slice'
import sales from './sales/reducer'
import search from './search/reducer'
import swap from './swap/reducer'
import transactions from './transactions/reducer'
import user from './user/reducer'
import users from './users/reducer'

const PERSISTED_KEYS: string[] = ['sales', 'user', 'transactions', 'lists']
const store = configureStore({
  reducer: {
    application,
    apollo,
    collections,
    orders,
    createOrder,
    mints,
    user,
    users,
    search,
    transactions,
    swap,
    sales,
    burn,
    burnV3,
    multicall,
    lists,
    logs,
    [dataApi.reducerPath]: dataApi.reducer,
    [routingApi.reducerPath]: routingApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: true, serializableCheck: false })
      .concat(dataApi.middleware)
      .concat(routingApi.middleware)
      .concat(save({ states: PERSISTED_KEYS, debounce: 1000 })),
  preloadedState: load({ states: PERSISTED_KEYS, disableWarnings: process.env.NODE_ENV === 'test' }),
})

store.dispatch(updateVersion())

setupListeners(store.dispatch)

export default store

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
